import React from "react";
import {
  ModalLayout,
  Pagination,
  SearchFilters,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import useDrumBallCertificate from "./useDrumBallCertificate";
import AddStatus from "../AddStatus";
import Style from "../drumBall.module.scss";
import { Table } from "../../../Global/Table";
import PassAll from "../../../Global/PassAll";

const DrumBallCertificate = ({ gliNumber }) => {
  const {
    paginationOptions,
    disableMultiSelect,
    drumBallState,
    certificateList,
    tableFields,
    isFetching,
    isLoading,
    searchInput,
    handleSearch,
    handleClearClick,
    handlePageSize,
    handlePagination,
    getRow,
    handleConfirmModal,
    handleConfirm,
    formik,
    passAllModal,
    handlePassAllClick,
    handlePassAll,
  } = useDrumBallCertificate();

  return (
    <>
      <h5 className="pro-ttl h5 pro-mb-2">{gliNumber}</h5>
      <div className={Style.btns}>
        <SearchFilters
          onSearchInput={handleSearch}
          showActions={false}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters
          handleClear={handleClearClick}
          searchInputProps={{
            value: searchInput,
          }}
        />
        <button
          className={`pro-btn pro-items-center pro-btn-outline`}
          onClick={handlePassAllClick}
        >
          <span className="material-symbols-outlined">check_circle</span>
          <span>Pass All</span>
        </button>
      </div>
      <Table
        multiSelect={disableMultiSelect ? false : true}
        data={certificateList?.data?.data || []}
        uniqueID={"id"}
        fields={tableFields}
        showCheckBox={true}
        SortIcon={<FaSort />}
        loading={isFetching}
        getRow={getRow}
        perpage={10}
        assignable={true}
        editable={false}
        deletable={false}
        assignText={"Submit"}
        assignIcon={
          <span className="material-symbols-outlined">check_circle</span>
        }
        handleAssign={handleConfirmModal}
        clear={drumBallState?.clear}
      />

      <ModalLayout
        show={drumBallState?.showAddDrumBallModal}
        handleClose={() => handleConfirmModal("")}
        title={"Choose status of submission?"}
      >
        <div className="pro-m-5">
          <AddStatus
            handleConfirm={handleConfirm}
            handleConfirmModal={() => handleConfirmModal("")}
          />
        </div>
      </ModalLayout>
      <Pagination
        currentPage={drumBallState.certificate?.currentPage}
        totalPageCount={Math.ceil(
          certificateList?.data?.total_count / certificateList?.data?.per_page,
        )}
        onPageChange={handlePagination}
        options={paginationOptions}
        onActionChange={handlePageSize}
        center
      />
      <ModalLayout
        show={passAllModal}
        title={"Pass All"}
        handleClose={handlePassAllClick}
        closeIcon={<span className="material-symbols-outlined">close</span>}
      >
        <PassAll
          formik={formik}
          handleSubmit={handlePassAll}
          handleCancel={handlePassAllClick}
        />
      </ModalLayout>
    </>
  );
};

export default DrumBallCertificate;
